<template>
  <section class="components-banner">
    <textLoader/>
  </section>
</template>

<script>
import textLoader from "cp/min-component/text-loader.vue";
export default {
  name: "banner-componnet",
  components: {
    textLoader
  },
  data() {
    return {
      isLoading: true,
      activeInterval: null
    };
  },
  created() {
    this.startAnimation();
  },
  methods: {
    startAnimation() {
      var vm = this;
      this.activeInterval = setTimeout(function () {
        vm.isLoading = false;
      }, 5000);
    }
  },
  destroyed() {
    clearTimeout(this.activeInterval);
  }
};
</script>

<style lang="less">
.components-banner {
  height: 300px;
  background: url("../assets/img/goran-ivos-343495-unsplash.jpg") top;
  position: relative;
  -webkit-animation: bgMove2 20s linear infinite;
  animation: bgMove2 20s linear infinite;
  background-attachment: fixed;
  background-size: 90%;
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.534);
  }
}
@-webkit-keyframes bgMove2 {
  0% {
    background-position: 0 0;
  }
  to {
    background-position: -400px 0;
  }
}

@keyframes bgMove2 {
  0% {
    background-position: 0 0;
  }
  to {
    background-position: -400px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue